import { render, staticRenderFns } from "./CarouselForm.vue?vue&type=template&id=dbf5ff22&scoped=true&"
import script from "./CarouselForm.vue?vue&type=script&lang=ts&"
export * from "./CarouselForm.vue?vue&type=script&lang=ts&"
import style0 from "./CarouselForm.vue?vue&type=style&index=0&id=dbf5ff22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbf5ff22",
  null
  
)

export default component.exports